import { render, staticRenderFns } from "./EditComplaintReason.vue?vue&type=template&id=765d8d59&"
import script from "./EditComplaintReason.vue?vue&type=script&lang=js&"
export * from "./EditComplaintReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports